import { render, staticRenderFns } from "./TbodyProfileCluster.vue?vue&type=template&id=5da124b7"
import script from "./TbodyProfileCluster.vue?vue&type=script&lang=js"
export * from "./TbodyProfileCluster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports